<p-dialog
  [(visible)]="isVisible"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [dismissableMask]="true"
  [closeOnEscape]="true"
  [blockScroll]="true"
  [style]="{ width: '870px', maxWidth: '95vw' }"
  styleClass="frw-dialog"
  (onHide)="onHide()">
  <ng-template pTemplate="header">
    <div class="frw-header">
      <span class="frw-header__icon"><i class="pi pi-megaphone"></i></span>
      <span class="frw-header__title">New feature in Remmi</span>
    </div>
  </ng-template>

  <div class="frw-loading" *ngIf="isLoading">
    <i class="pi pi-spin pi-spinner"></i>
  </div>

  <!-- List mode: one row per pending feature, each viewed or ignored on its own. -->
  <div class="frw-list" *ngIf="isListView">
    <div class="frw-list__row" *ngFor="let item of listReleases; trackBy: trackById">
      <div class="frw-list__text">
        <app-release-pill [value]="item.type" [label]="item.type_label"></app-release-pill>
        <p class="frw-list__title">{{ item.title }}</p>
        <p class="frw-list__banner">{{ item.banner_text || item.summary }}</p>
      </div>
      <div class="frw-list__actions">
        <button type="button" class="_primary-btn" (click)="viewFromList(item)">View</button>
        <button type="button" class="_outline-btn" (click)="ignoreFromList(item)">Ignore</button>
      </div>
    </div>
  </div>

  <div class="frw-body" *ngIf="release && !isLoading">
    <ul class="frw-steps">
      <li
        class="frw-steps__item"
        *ngFor="let section of sections; let i = index"
        [class.frw-steps__item--active]="i === activeIndex"
        [class.frw-steps__item--done]="i < activeIndex"
        [title]="'Go To ' + section.label"
        (click)="goTo(i)">
        <span class="frw-steps__circle"
          ><i class="pi pi-check" *ngIf="i < activeIndex; else stepNumber"></i><ng-template #stepNumber>{{ i + 1 }}</ng-template></span
        >
        <span class="frw-steps__label">{{ section.label }}</span>
      </li>
    </ul>

    <div class="frw-content">
      <a href="javascript:void(0)" class="frw-back" *ngIf="mode === 'list'" (click)="backToList()">
        <i class="pi pi-angle-left"></i>
        All features
      </a>

      <p class="frw-eyebrow">Step {{ activeIndex + 1 }} · {{ activeSection?.label }}</p>
      <h3 class="frw-title">{{ release.title }}</h3>
      <p class="frw-subtitle" *ngIf="release.summary">{{ release.summary }}</p>

      <ng-container [ngSwitch]="activeSection?.key">
        <ng-container *ngSwitchCase="'overview'">
          <p class="frw-details" *ngIf="release.details">{{ release.details }}</p>

          <div class="frw-why" *ngIf="release.benefit?.trim()">
            <span class="frw-why__icon"><i class="pi pi-check"></i></span>
            <div>
              <p class="frw-why__heading">Why we added this</p>
              <p class="frw-why__text">{{ release.benefit }}</p>
            </div>
          </div>

          <div class="frw-frame" *ngIf="images.length">
            <img [src]="images[0].url" [alt]="images[0].caption || release.title" />
            <p class="frw-frame__caption" *ngIf="images[0].caption">{{ images[0].caption }}</p>
          </div>
        </ng-container>

        <ng-container *ngSwitchCase="'how'">
          <ol class="frw-how">
            <li class="frw-how__step" *ngFor="let step of release.how_it_works; let i = index">
              <span class="frw-how__number">{{ i + 1 }}</span>
              <span class="frw-how__text">{{ step }}</span>
            </li>
          </ol>
        </ng-container>

        <ng-container *ngSwitchCase="'example'">
          <div class="frw-frame" *ngIf="images.length">
            <div class="frw-gallery">
              <button type="button" class="frw-gallery__arrow frw-gallery__arrow--prev" *ngIf="images.length > 1" (click)="prevImage()">
                <i class="pi pi-angle-left"></i>
              </button>
              <img [src]="images[exampleIndex]?.url" [alt]="images[exampleIndex]?.caption || release.title" />
              <button type="button" class="frw-gallery__arrow frw-gallery__arrow--next" *ngIf="images.length > 1" (click)="nextImage()">
                <i class="pi pi-angle-right"></i>
              </button>
            </div>
            <p class="frw-frame__caption" *ngIf="images[exampleIndex]?.caption">{{ images[exampleIndex].caption }}</p>
            <p class="frw-frame__counter" *ngIf="images.length > 1">{{ exampleIndex + 1 }} / {{ images.length }}</p>
          </div>

          <!-- Videos play inside the window; never link out. -->
          <div class="frw-frame" *ngFor="let video of videos; trackBy: trackById">
            <!-- src on <video> itself, not a <source> child: Angular binds src after the element exists, and a
                 <source> added that late is never picked up without a manual video.load(), so the player sat
                 empty at 0:00. No `type` hint either: MOV uploads are video/quicktime, which Chrome rejects by
                 type even when it can play the file. -->
            <video class="frw-video" controls playsinline preload="metadata" [src]="video.url"></video>
            <p class="frw-frame__caption" *ngIf="video.caption">{{ video.caption }}</p>
          </div>
        </ng-container>
      </ng-container>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <div class="frw-footer" *ngIf="release && !isLoading">
      <label class="frw-footer__check" *ngIf="isTracked">
        <input type="checkbox" [(ngModel)]="isDontShowAgain" />
        <span>Don't show this again</span>
      </label>
      <span class="frw-footer__progress" *ngIf="!isTracked">Preview · Step {{ activeIndex + 1 }} of {{ sections.length }}</span>
      <div class="frw-footer__actions">
        <button type="button" class="_outline-btn frw-btn" (click)="close()">Close</button>
        <button type="button" class="_outline-primary-btn frw-btn" *ngIf="activeIndex > 0" (click)="back()">
          <i class="pi pi-angle-left"></i> Back
        </button>
        <button type="button" class="_primary-btn frw-btn" (click)="next()">
          <ng-container *ngIf="isLastSection; else nextLabel">Finish</ng-container>
          <ng-template #nextLabel>Next <i class="pi pi-angle-right"></i></ng-template>
        </button>
      </div>
    </div>
  </ng-template>
</p-dialog>
